/* sucrase/dist/esm/parser/util/whitespace.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const charcodes_1 = require("22746c8ce8") /* ./charcodes */;
    // https://tc39.github.io/ecma262/#sec-white-space
    exports.WHITESPACE_CHARS = [
        0x0009,
        0x000b,
        0x000c,
        charcodes_1.charCodes.space,
        charcodes_1.charCodes.nonBreakingSpace,
        charcodes_1.charCodes.oghamSpaceMark,
        0x2000, // EN QUAD
        0x2001, // EM QUAD
        0x2002, // EN SPACE
        0x2003, // EM SPACE
        0x2004, // THREE-PER-EM SPACE
        0x2005, // FOUR-PER-EM SPACE
        0x2006, // SIX-PER-EM SPACE
        0x2007, // FIGURE SPACE
        0x2008, // PUNCTUATION SPACE
        0x2009, // THIN SPACE
        0x200a, // HAIR SPACE
        0x202f, // NARROW NO-BREAK SPACE
        0x205f, // MEDIUM MATHEMATICAL SPACE
        0x3000, // IDEOGRAPHIC SPACE
        0xfeff, // ZERO WIDTH NO-BREAK SPACE
    ];
    exports.skipWhiteSpace = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
    exports.IS_WHITESPACE = new Uint8Array(65536);
    for (const char of exports.WHITESPACE_CHARS) {
        exports.IS_WHITESPACE[char] = 1;
    }
}
